<!-- Header -->
<div class="row page-header bg-primary fixed-top">
  <div class="col-8">
    <button class="toggle-btn btn shadow-none" (click)="toggleSideMenu()">
      <i-bs class="text-light" name="list" width="30" height="30" *ngIf="showSideMenu === 'none'"></i-bs>
      <i-bs class="text-light" name="chevronLeft" width="30" height="30" *ngIf="showSideMenu === 'block'"></i-bs>
    </button>

    <span class="provider-name text-light">{{ loginData?.user_details?.provider_name }}</span>
  </div>
  <div class="col-4">
    <span class="user-name text-light mr-2 mt-2">
      {{ loginData?.user_details?.user_name }}
      <i-bs class="text-light cursor-pointer" name="caretDownFill" width="12" height="12" [ngbPopover]="profilePopContent" [autoClose]="true"></i-bs>
    </span>
    <!--<div class="logout text-light mr-2" (click)="onLogout()">Logout</div>-->
  </div>
</div>

<div class="d-flex" id="wrapper">
  <!-- Sidebar -->
  <div class="bg-light border-right" id="sidebar-wrapper" [style.display]="showSideMenu">
    <ul class="list-group list-group-flush bg-light">
      <li class="item list-group-item bg-light" *ngFor="let menu of loginData?.menu"> <!-- (click)="menuClick(menu)" -->
        <a class="link text-muted" [routerLink]="menu.route" routerLinkActive="active" #rla="routerLinkActive">
          <!-- Create Coupon -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'plusCircleFill' : 'plusCircle'" width="25" height="25" *ngIf="menu.menu_code == 'R-CC'"></i-bs>

          <!-- Coupons -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'tagsFill' : 'tags'" width="25" height="25" *ngIf="menu.menu_code == 'C-CL' || menu.menu_code == 'R-CL' || menu.menu_code == 'D-CL'"></i-bs>

          <!-- Create Circular -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'calendar2PlusFill' : 'calendar2Plus'" width="25" height="25" *ngIf="menu.menu_code == 'R-MCR'"></i-bs>
          
          <!-- Circulars -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'collectionFill' : 'collection'" width="25" height="25" *ngIf="menu.menu_code == 'R-CRL'"></i-bs>

          <!-- Reports -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'barChartFill' : 'barChart'" width="25" height="25" *ngIf="menu.menu_code == 'C-RP' || menu.menu_code == 'R-RP' || menu.menu_code == 'D-RP'"></i-bs>

          <!-- Payments -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'creditCardFill' : 'creditCard'" width="25" height="25" *ngIf="menu.menu_code == 'C-PA' || menu.menu_code == 'R-PA' || menu.menu_code == 'D-PA'"></i-bs>

          <!-- Loyalty -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'starFill' : 'star'" width="25" height="25" *ngIf="menu.menu_code == 'R-LOY'"></i-bs>

          <!-- Sales Data -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'clipboardDataFill' : 'clipboardData'" width="25" height="25" *ngIf="menu.menu_code == 'R-SD'"></i-bs>

          <!-- SMS Campaign -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'phoneFill' : 'phone'" width="25" height="25" *ngIf="menu.menu_code == 'R-SMS'"></i-bs>

          <!-- Push Notification Campaign -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'chatSquareDotsFill' : 'chatSquareDots'" width="25" height="25" *ngIf="menu.menu_code == 'R-PNO'"></i-bs>


          <!-- ADMIN LINKS -->
          <!-- TCB -->
          <i-bs class="text-muted" [name]="rla.isActive == true ? 'tagsFill' : 'tags'" width="25" height="25" *ngIf="menu.menu_code == 'A-TCB'"></i-bs>

          <!-- Link label -->
          <div [class]="rla.isActive == true ? 'label fw-bold' : 'label'">{{ menu.menu_name }}</div>
        </a>
      </li>
    </ul>

    <br>
  </div>

  <!-- Page Content -->
  <div class="pt-1 pl-0" id="page-content-wrapper">
    <!-- Content -->
    <div class="container-fluid pt-4 mt-4">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>

<!-- Profile Popover-->
<ng-template #profilePopContent>
  <div class="container popover-outer profile-popover p-0">
    <ul class="list-group list-group-flush">
      <li class="list-group-item border-0 m-0 p-0">
        <span class="link text-muted" (click)="onChangePassword()">Change Password</span>
      </li>
      <li class="list-group-item border-0 m-0 p-0">
        <span class="link text-muted" (click)="onLogout()">Logout</span>
      </li>
    </ul>
  </div>
</ng-template>

